import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Caret from './icons/Caret';

const InfoBlock = ({
    defaultExpanded = true,
    showToggleArrow = true,
    title,
    text,
}) => {
    const [isExpand, setExpand] = useState(defaultExpanded);

    return (
        <div
            className={classNames("InfoBlock", {
                expandable: showToggleArrow,
                expanded: showToggleArrow && isExpand,
            })}
            onClick={() => showToggleArrow && setExpand(!isExpand)}
        >
            <div className="InfoBlock__title">
                {title}
                {showToggleArrow && (
                    <div className="InfoBlock__title__toggle">
                        <Caret isOpen={isExpand} />
                    </div>
                )}
            </div>
            <div className="InfoBlock__text">
                {text}
            </div>
        </div>
    );
}

InfoBlock.propTypes = {
    defaultExpanded: PropTypes.bool,
    showToggleArrow: PropTypes.bool,
    title: PropTypes.string.isRequired,
    text: PropTypes.any.isRequired,
}

export default InfoBlock;